<template>
  <div>
    <el-row class="movie-list">
      <el-row>
        <h2>我的审批</h2>
        <el-button
          size="mini"
          type="danger"
          @click="handleClear"
        >清空</el-button>
      </el-row>
      <el-card>
        <el-table
          :data="dataList"
          :show-header="true"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
          />
          <el-table-column
            prop="createAt"
            label="创建时间"
          />
          <el-table-column
            prop="bizType"
            label="业务类型"
          />
          <el-table-column
            prop="bizPayload"
            label="业务数据"
          />
          <el-table-column
            prop="status"
            label="审批状态"
          />
        </el-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { getUserApprovalRequests } from '@/api/user'

export default {
  name: 'MyApproval',
  data() {
    return {
      dataList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      var queryParams = {}
      queryParams.pn = 1
      getUserApprovalRequests(queryParams).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data.list
        }
      })
    },
    handleClear() {
      this.$confirm('确定要清空所有消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.info('clear')
      }).catch(() => {
        this.$message.info('已取消')
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding-top: 8px;
    padding-left: 0.5%;
    padding-right: 0.5%;
  }
}

.movie-list {
  padding-top: 15px;
  padding-left: 6%;
  padding-right: 6%;
}
</style>
